import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mx-auto min-h-full"
}
const _hoisted_2 = { class: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-4 mb-4" }

import {
  ref,
  watch,
  computed,
  onBeforeMount,
  onMounted,
} from 'vue';
import { useRouter } from 'vue-router';
import usePluginStore from '@/store/plugin/plugin';
import InstagramLiveMetadata from '@/models/plugin/instagramLiveMetadata';
import Plugin from '@/models/plugin/plugin';
import { useI18n } from 'vue-i18n';
import SimpleFooter from '@/components/tailwind/footer/SimpleFooter.vue';
import SimpleHeader from '@/components/tailwind/header/SimpleHeader.vue';
import PluginConnectionAlert from '@/components/tailwind/plugin/PluginConnectionAlert.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PluginLivesLayout',
  setup(__props) {

const router = useRouter();
const { t } = useI18n();
const {
  pluginsDoGetMy,
  pluginGetSharedWithMeLiveMetadatas,
} = usePluginStore();

/*
  Data
*/
const dataLoaded = ref(false);
const isLoading = ref(true);
const plugin = ref({} as Plugin);
const newPlugins = ref([] as Plugin[]);
const metadatasSharedWithMe = ref([] as InstagramLiveMetadata[]);

/*
  Computed
*/
const pluginId = computed(() => router.currentRoute.value.params.pluginId);
const pluginType = computed(() => router.currentRoute.value.params.pluginType);

/*
  Methods
*/
const handleClose = () => {
  router.push({
    name: 'PluginsManagerPage',
  });
};

// const deletePlugin = async (plugin: Plugin) => {
//   await pluginsDoDelete(plugin.id)
//     .then(() => {
//       notify({
//         type: 'success',
//         title: 'Sucesso',
//         text: 'Plugin removido com sucesso',
//       });
//       plugins.value = plugins.value.filter((p) => p.id !== plugin.id);
//     }).catch((error) => {
//       console.error('error', error);
//       notify({
//         type: 'error',
//         title: 'Erro',
//         text: 'Não foi possível remover o plugin',
//       });
//     });
// };
const redirectDashboard = ((error: string) => router.push({
  name: 'DashboardPage',
  query: {
    message: 'Não foi possível carregar a página. Tente novamente em instantes.',
    detail: error,
    type: 'error',
  },
}));
const loadPlugins = () => {
  pluginsDoGetMy(`${pluginId.value}`, undefined, `${pluginType.value}`)
    .then((response) => {
      if (response !== undefined) {
        // Get the first plugin from the appropriate array
        const plugins = pluginType.value === 'facebook'
          ? response.facebookPlugins
          : response.instagramPlugins;
        if (plugins.length > 0) {
          plugin.value = new Plugin(plugins[0]);
        }
      }
    }).catch((error) => {
      console.error('error', error);
      redirectDashboard(error.toString());
    });
};
const loadMetadatasSharedWithMe = () => {
  pluginGetSharedWithMeLiveMetadatas({
    page: 1,
    limit: 100,
    orderBy: 'createdAt',
    order: -1,
  })
    .then((response) => {
      if (response !== undefined) {
        metadatasSharedWithMe.value = response.data;
      }
    }).catch((error) => {
      console.error('error', error);
      redirectDashboard(error.toString());
    });
};
const load = async () => {
  isLoading.value = true;
  await loadPlugins();
  await loadMetadatasSharedWithMe();

  isLoading.value = false;
  dataLoaded.value = true;
};

/*
  Hooks
*/
onBeforeMount(async () => {
  await load();
});
onMounted(() => {
  setTimeout(() => {
    dataLoaded.value = true;
  }, 500);
});
watch(newPlugins, () => {
  load();
});

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (dataLoaded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(SimpleHeader, {
            "on-close": handleClose,
            pages: [
        { name: _unref(t)('sidemenu.navigation.integration.title'), href: _unref(router).resolve({ name: 'PluginsManagerPage' }).href, current: false },
        { name: `@${plugin.value.name}`, href: '#', current: true },
      ]
          }, null, 8, ["pages"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(PluginConnectionAlert, { plugin: plugin.value }, null, 8, ["plugin"])
          ]),
          _createVNode(_component_RouterView, { plugin: plugin.value }, null, 8, ["plugin"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(SimpleFooter, { horizontal: true })
  ], 64))
}
}

})